import * as types from './types';

const initialState = {
  GetStrategicRelationships: {},
  PostStrategicRelationships: {}
};

export default function clientsReducer(state = initialState, action) {
  switch (action.type) {
    case 'RESET_KEY':
      return {
        ...state,
        [action.payload.key]: {}
      };
    case types.GET_STRATEGIC_RELATIONSHIPS_SUCCESS: {
      return {
        ...state,
        GetStrategicRelationships: action.payload
      };
    }
    case types.GET_STRATEGIC_RELATIONSHIPS_FAILURE:
      return { ...state, error: action.payload };

    case types.POST_STRATEGIC_RELATIONSHIPS_SUCCESS: {
      return {
        ...state,
        PostStrategicRelationships: action.payload
      };
    }
    case types.POST_STRATEGIC_RELATIONSHIPS_FAILURE:
      return { ...state, error: action.payload };

    default:
      return state;
  }
}
